__turbopack_context__.v({
  "btn": "Form-module-scss-module__cuPPDq__btn",
  "btnText": "Form-module-scss-module__cuPPDq__btnText",
  "btnWrapper": "Form-module-scss-module__cuPPDq__btnWrapper",
  "form": "Form-module-scss-module__cuPPDq__form",
  "inputsWrapper": "Form-module-scss-module__cuPPDq__inputsWrapper",
  "main": "Form-module-scss-module__cuPPDq__main",
  "notation": "Form-module-scss-module__cuPPDq__notation",
  "row": "Form-module-scss-module__cuPPDq__row",
  "subtitle": "Form-module-scss-module__cuPPDq__subtitle",
  "textWrapper": "Form-module-scss-module__cuPPDq__textWrapper",
  "title": "Form-module-scss-module__cuPPDq__title",
});
